import { orchestrator } from 'satcheljs';
import setErrorDialogState from '../mutators/setErrorDialogState';
import { accountIsInErrorState } from 'owa-accounts-store';

orchestrator(accountIsInErrorState, ({ accountState }) => {
    setErrorDialogState(false, accountState);
});
